<template>
  <div id="app">
      <nav class="navbar is-fixed-top">
        <div class="navbar-brand">
          <a class="navbar-item" href="/">
            <img src="/static/img/tclogo.png" alt="TrustCircle" width="28" height="28">
            &nbsp;&nbsp;
            <span>SCARF Project</span>
          </a>

          <div class="navbar-burger" @click="toggleMenu" :class="{ 'is-active': isMenuActive }" data-target="navMenu">
            <i v-if="isMenuActive" class="fa fa-times tc-fa-menu fa-2x"></i>
            <i v-else class="fa fa-bars tc-fa-menu fa-2x"></i>
          </div>
        </div>

        <div id="navMenu" class="navbar-menu" :class="{ 'is-active' : isMenuActive }">
          <div class="navbar-start" @click="toggleMenu">
             <a class="navbar-item" href="/check-result">Check Result</a>
          <!-- end:navbar-start -->
          </div>
        </div>
      </nav>
    <div class="fixed-top-spacer"></div>

    <router-view class='border'></router-view>
    <!-- </div> -->

    <footer class="footer">
      <div class="container">
        <!-- <div class="has-text-centered">Get notified about updates.</div> -->
        <!-- <br> -->
        <div class="columns">
          <div class="has-text-centered column is-4">
            <br>
            2019 &copy;
            <a href="https://trustcircle.co">TrustCircle</a>,
            <a href="http://www.scarfindia.org/">SCARF</a>,
            &amp;
            <a href="https://www.nihr.ac.uk/">NIHR</a>
          </div>
          <div class="has-text-centered column is-4">
            <a target="_blank" href="http://twitter.com/trustcircle">
              <span class="icon">
                <i class="fab fa-twitter"></i>
              </span>
            </a>
            <a target="_blank" href="https://www.linkedin.com/company/10691880">
              <span class="icon">
                <i class="fab fa-linkedin"></i>
              </span>
            </a>
            <a target="_blank" href="http://facebook.com/trustcircleco">
              <span class="icon">
                <i class="fab fa-facebook-f"></i>
              </span>
            </a>
            <a href="mailto:info@trustcircle.co">
              <span class="icon">
                <i class="fas fa-envelope"></i>
              </span>
            </a>
            <br>
            <br>
            Created with
            <span class="icon is-danger">
              <i class="fa fa-heart"></i>
            </span>
            by TrustCircle Team
          </div>
          <div class="has-text-centered column is-4">
            <div id="sister">
              <br>
              <a target="_blank" :href="urlTermsAndPrivacy">Terms &amp; Privacy Policy</a>
            <br>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="has-text-centered column is-4">
            A Collaborating Centre
            <br>
            <img src="static/img/who-centre-for-mental-health-research-scarf-trustcircle-partner.png" alt="WHO">
            <br>
            for Mental Health Research &amp; Training
          </div>
          <div class="has-text-centered column is-4">
            <!-- <br>
            TrustCircle Products
            <br>
            <a target="_blank" href="https://trustcircle.co/tests/">mHealth Tests</a> |
            <a target="_blank" href="https://trustcircle.co/blog/">mHealth Blog</a> |
            <a target="_blank" href="https://trustcircle.co/insights/">mHealth Insights</a> |
            <a target="_blank" href="https://trustcircle.co/care/">mHealth Care</a> |
            <a target="_blank" href="https://trustcircle.co/connect/">mHealth Connect</a> |
            <a target="_blank" href="https://trustcircle.co/smiles/">mHealth Smiles</a> -->
          </div>
          <div class="has-text-centered column is-4">
            <br>
            <img src="static/img/funded-by-NIHR.png" alt="NIHR">
            <br>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      isMenuActive: false,
      urlTermsAndPrivacy: `${this.$helpers.urlMainWebsite}/terms-and-privacy`,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
  },
};
</script>

<style scoped>
.is-fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 2;

  opacity: 0.9;
}

.fixed-top-spacer {
  width: 100%;
  height: 54px;
}

.icon {
  height: 32px;
  width: 32px;
}
.icon-small {
  height: 20px;
  width: 20px;
}

.tc-fa-menu {
  padding: 0.7rem;
  color: #999;
}

.is-danger {
  color: red;
}

.navbar-item {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue